import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import './error-component.scss';
import { ApiError, RestApiError } from '../../api/RestClient';
import { useTheme } from '@context/themeContext';

type Props = {
    children?: React.ReactNode;
    error?: ApiError | RestApiError | null;
    warning?: string;
};

const ErrorComponent: React.FC<Props> = ({ children, error, warning }) => {
    const { theme } = useTheme();

    const getDescription = (error: ApiError | RestApiError) => {
        if ('error_description' in error) {
            return error.error_description;
        }
        if ('message' in error) {
            return error.message;
        }
    };

    if (error) {
        return (
            <div className="error-wrapper">
                <ErrorOutlineIcon color="error" sx={{ fontSize: '50px' }} />
                <div className={`error-message ${theme}`}>{getDescription(error)}</div>
            </div>
        );
    }
    if (warning) {
        return (
            <div className="error-wrapper">
                <WarningAmberIcon color="warning" sx={{ fontSize: '50px' }} />
                <div className="error-message">{warning}</div>
            </div>
        );
    }

    return <>{children}</>;
};

export default ErrorComponent;
